import React from 'react';
import { Provider } from 'react-redux';
import { ApplicationStore } from './AppReducer';

export const StoryFlowStoreProvider: React.FC = ({ children }) => {
    return <Provider store={ApplicationStore}>{children}</Provider>;
};
